import { useQuery } from "@tanstack/react-query";
import { pollMRDC } from "@/api/v1-jwt/mrdc/mrdc";

export const usePollMRDC = ({
  id,
  queryFn,
  queryKey,
  status,
  enabled,
  ...rest
} = {}) => {
  const isEnabled = !!id && enabled !== false;

  return useQuery({
    queryKey: ["mrdc", "poll", id],
    queryFn: async () => {
      return await pollMRDC({ id });
    },
    enabled: isEnabled,
    ...rest,
  });
};
